export const bodyZoomScale = () => {
  const bodyZoom = parseFloat(getComputedStyle(document.body).zoom || '1');
  return isNaN(bodyZoom) ? 1 : bodyZoom;
};
